import React, { useContext, useEffect, useState } from 'react';

import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  List,
  ListItem,
  ListItemText,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@material-ui/core';

import { makeStyles } from '@material-ui/core/styles';

import {
  useHistory,
  withRouter,
} from 'react-router-dom';

import PropTypes from 'prop-types';

import AllDataTable from '../../charts/allDataTable';
import Footer from '../../fields/footer';
import Header from '../../fields/header';
import CustomLineChart from '../../charts/customLineChart';
import MenuDrawerTechnical from '../../fields/menuDrawerTechnical';
import MonthDataTable from '../../charts/monthDataTable';
import SpinnerLoading from '../../feedback/spinnerLoading';

import { getPrograms } from '../../../utils/comms';
import { getIndicatorsLabels } from '../../../utils/helpers';

import translations from '../../../languages/i18n';

import generalStyles from '../../../styles/generalStyles';
import { sectionTitle } from '../../../styles/formElementsStyles';

// NOTA: Per poder emprar el react-router-dom i enllaçar pàgines s'ha de convertir el component en una funció i exportar-lo embolicat per withRouter
// En cas de que el component sigui un fill directe de Route no fa falta fer-ho
// Explicat al punt 2.1. Using withRouter de https://dev.to/projectescape/programmatic-navigation-in-react-3p1l

import { SessionContext } from '../../../utils/context';

// *****************************************************************************
// BORRAR EN OBTENIR LES DADES DEL SERVIDOR
import { response } from './exemple_dades_1';
// *****************************************************************************

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

function DetailedDashboard({ lang, handleChangeLang }) {
  const classesProva = useStyles();  
  const sessionContext = useContext(SessionContext);
  const classes = generalStyles();
  const sectionTitleStyle = sectionTitle();

  
  const [dataStatistics, setDataStatistics] = useState([]);
  const [indicator, setIndicator] = useState('numPacientsEnrolats'); // numPacientsEnrolats, numPacientsActius
  // const [indicatorsList, setIndicatorsList] = useState([]);
  const [onlylabels, setOnlyLabels] = useState([]);
  const [month, setMonth] = useState('');
  const [monthsList, setMonthsList] = useState([]);
  const [ready, setReady] = useState(false);
  const [showDrawer, setShowDrawer] = useState(false);
  const [showLoading, setShowLoading] = useState(false);

  const history = useHistory();

  useEffect(() => {
    const getNumberEnrolledPatientsStatsFromServer = async () => {
      setShowLoading(true);
      // const response = await getNumberEnrolledPatientsStats(sessionContext.userToken);
      // Agafam totes les etiquetes de les estadístiques

    
      setShowLoading(false);
      if (response.status === 200) { // Tenim llistat        

        // Extreim les etiquetes de l'indicador
        const uniqueLabels = getIndicatorsLabels(response.statistics[indicator]); 
        // Agafam els anys-mesos
        const monthsFromServer = response.statistics[indicator].map((item) => item.date);

        setOnlyLabels(uniqueLabels);
        setMonthsList(monthsFromServer);
        setDataStatistics(response.statistics[indicator]);
        setReady(true);
      
            
      } else if (response === 400) { // Error amb les dades
        console.log('Error 400');
      } else { // Login KO. Altres errors
        console.log(response);
      }
    };
    getNumberEnrolledPatientsStatsFromServer();
  }, []); // [] Indica que l'useEffect només s'executa una vegada, no a cada render


  const showMenuDrawer = (show) => {
    setShowDrawer(show);
  };

  // Pinta el llistat de anys-mesos
  const renderMonthsList = (monthsList) => {
    return(
      <List component='paper'>
        {monthsList.map((month) => (
          <ListItem button onClick={()=> setMonth(month)}>
            <ListItemText primary={month} />
          </ListItem>
          ))}
      </List>        
    );
  }

   // Pinta un select de anys-mesos
   const renderMonthsSelect = (monthsList) => {
    return(
      <FormControl fullWidth>
        <Select variant='outlined' displayEmpty value={month} onChange={(event)=> setMonth(event.target.value)}>
          <MenuItem value='' disabled>{translations['_selectMonth']}</MenuItem>
        {monthsList.map((month) => (
          <MenuItem value={month} key={`${indicator}_${month}`}>{month}</MenuItem>
          ))}
        </Select>
      </FormControl>
      
    );
  }

     // Pinta un select d'indicadors'
     /* const renderIndicatorsSelect = () => {
      return(
        <FormControl fullWidth>
          <Select variant='outlined' displayEmpty value={indicator} onChange={(event)=> setIndicator(event.target.value)}>
            <MenuItem value='' disabled>{translations['_selectMonth']}</MenuItem>
          {indicatorsList.map((indicator) => (
            <MenuItem value={indicator} key={`${indicator}`}>{indicator}</MenuItem>
            ))}
          </Select>
        </FormControl>
        
      );
    } */

  // Pinta una taula per mes
  /* const renderDataTableMonthly = (data) => {
    let total =0;
    return (
      <Paper>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell colSpan='2' style={{fontWeight: 'bold', textAlign: 'center'}}>{data.date}</TableCell>              
            </TableRow>
            <TableRow>
              <TableCell style={{fontWeight: 'bold'}}>{translations['_program']}</TableCell>
              <TableCell style={{fontWeight: 'bold'}}>{translations['_numEnrolled']}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>          
            {Object.entries(data).map(([key, value]) => {
              if (key !== 'date') {
                total = total + value;
                return (
                  <TableRow key={key} hover>
                    <TableCell>{key}</TableCell>
                    <TableCell>{value}</TableCell>
                  </TableRow>
                )
              }
            })}
            <TableRow>
              <TableCell style={{fontWeight: 'bold', textAlign: 'right'}}>{translations['_total']}</TableCell>
              <TableCell>{total}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Paper>
    )
  }; */

  return (
    <div className={classes.content}>
      <SpinnerLoading show={showLoading} />
      {/* ATENCIÓ: el role ve del servidor amb la primera lletra en majuscula, jo ho necessit tot en minuscula */}
      <Header type={sessionContext.role.toLowerCase()} lang={lang} handleChangeLang={handleChangeLang} handleShowDrawer={(show) => showMenuDrawer(show)} />
      <MenuDrawerTechnical type={sessionContext.role.toLowerCase()} showDrawer={showDrawer} handleShowDrawer={(show) => showMenuDrawer(show)} />
      <div className={classes.body}>
        <Grid container direction='column' spacing={2}>
          {/* ----------------------- Fila 0 ----------------------- */}
          <Grid item xs={12}>
            {/* <BreadCrumb role={sessionContext.role.toLowerCase()} home='listPrograms' lang={lang} /> */}
          </Grid>
          {/* ----------------------- Fila ----------------------- */}
          <Grid item className={sectionTitleStyle.root}>
            <Grid container justify='space-between' spacing={2}>
              <Grid item>                
                <Typography variant='h4' component='div' className={sectionTitleStyle.title}>{translations['_numEnrolledPatientsByProgram']}</Typography>
                <Typography variant='body1' component='div'>{translations['_numEnrolledPatientsByProgramDesc']}</Typography>
              </Grid>
            </Grid>
          </Grid>
          {/* ----------------------- Fila ----------------------- */}
          <Grid item>
            <Grid container justify='center' spacing={2}>
              <Grid item xs={10}>
              {ready && <CustomLineChart data={dataStatistics} />}
              </Grid>
            </Grid>
          </Grid>
          {/* ----------------------- Fila ----------------------- */}
          <Grid item className={sectionTitleStyle.root}>
            <Grid container justify='space-between' spacing={2}>
              <Grid item>                
                <Typography variant='h4' component='div' className={sectionTitleStyle.title}>{translations['_numEnrolledPatientsByProgramTable']}</Typography>
                <Typography variant='body1' component='div'>{translations['_numEnrolledPatientsByProgramTableDesc']}</Typography>
              </Grid>
            </Grid>
          </Grid>
          {/* ----------------------- Fila ----------------------- */}
          <Grid item>
            <Grid container justify='center' spacing={2}>
              <Grid item xs={10}>
                <AllDataTable data={dataStatistics} labels={onlylabels}/>
              </Grid>
            </Grid>
          </Grid>
          {/* ----------------------- Fila ----------------------- */}
          <Grid item className={sectionTitleStyle.root}>
            <Grid container justify='space-between' spacing={2}>
              <Grid item>                
                <Typography variant='h4' component='div' className={sectionTitleStyle.title}>{translations['_numEnrolledPatientsByProgramMonthlyTable']}</Typography>
                <Typography variant='body1' component='div'>{translations['_numEnrolledPatientsByProgramMonthlyTableDesc']}</Typography>
              </Grid>
            </Grid>
          </Grid>
          {/* ----------------------- Fila ----------------------- */}
          <Grid item>
            <Grid container justify='center' spacing={2}>              
              <Grid item xs={4}>
                {/* <Typography variant='body' component='div'>Escoge un mes</Typography> */}
                {/* renderMonthsList(monthsList) */}
                {renderMonthsSelect(monthsList)}
              </Grid>
              <Grid item xs={4} style={{display: 'flex', alignItems: 'center'}}> {/* Aquest estil es necessari per mostrar el text d'informació no disponible centrat */}               
                {/* month ? renderDataTableMonth(month) : translations['_infoNotAvailable'] */ }
                {month ? <MonthDataTable data={dataStatistics} month={month}/> : translations['_infoNotAvailable']}
              </Grid>
            </Grid>
          </Grid>
          {/* ----------------------- Fila N ----------------------- */}
          {/*dataStatistics.map((data) => {
            return (
              <Grid item>
                <Grid container justify='center' spacing={2}>
                  <Grid item xs={4}>
                    {renderDataTableMonthly(data)}
                  </Grid>
                </Grid>
              </Grid>
            )
          })*/}
        </Grid>
      </div>
      <Footer />
    </div>
  );
}

export default withRouter(DetailedDashboard);

// Indica i controla els props que se han de passar al component
DetailedDashboard.propTypes = {
  handleChangeLang: PropTypes.func.isRequired,
  lang: PropTypes.string.isRequired,
};

